var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.27273 9.3C3.54887 9.3 3.77273 9.07614 3.77273 8.8V5.5C3.77273 4.17259 4.29572 2.90037 5.22534 1.963C6.15483 1.02577 7.41459 0.5 8.72727 0.5H11.5V3.9H8.72727C8.30399 3.9 7.89889 4.06959 7.60087 4.3701C7.30298 4.67047 7.13636 5.07699 7.13636 5.5V8.8C7.13636 9.07614 7.36022 9.3 7.63636 9.3H11.3609L10.5179 12.7H7.63636C7.36022 12.7 7.13636 12.9239 7.13636 13.2V21.5H3.77273V13.2C3.77273 12.9239 3.54887 12.7 3.27273 12.7H0.5V9.3H3.27273Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.b902dfc3a3fe12e78ae368e756d2be94.svg";
export { ForwardRef as ReactComponent };